module.exports = __webpack_public_path__ + "static/bottle-dunkin-original-32oz-e3035d1392f1e07ef5734c9af52ba350.png";